import {createContext, useContext, useReducer, useState} from "react";
import newProductReducer from "../reducers/NewProductReducer";
import {DISCOUNT_TYPES} from "../../Constants/Constants";


const NewProductContext = createContext();

export function useNewProduct() {
    return useContext(NewProductContext);
}

export function NewProductProvider({ children }) {
    const [product, dispatch] = useReducer(newProductReducer, {
        product_visual_imagery: [],
        addresses: [
            { shop_address_id: "", quantity: "1" }
        ],
        price: "0",
        attributes: [],
        bundle: [],
        discount: DISCOUNT_TYPES.NO_DISCOUNT,
        feedbacks: [],
    });

    const [errors, setErrors] = useState([]);
    const [data, setData] = useState({});
    return (
        <NewProductContext.Provider value={{product, dispatch, errors, setErrors, data, setData}}>
            { children}
        </NewProductContext.Provider>
    )
}